import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { deleteDyanmicUiFn, getDyanmicUiFn, postDyanmicUiFn } from "../../Services/DynamicPageUi";
import { toast } from "react-toastify";


import { useNavigate } from "react-router-dom";
import { Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { Delete, Edit } from "@mui/icons-material";
import PageValue from "./ViewPageValue";

export default function DynamicUIList() {
    const [search, setSearch] = useState("")
    const navigate = useNavigate()


    const { data, refetch } = useQuery(["page-design-list", search], () => getDyanmicUiFn({ search }))

    const { mutate: DeleteMsg } = useMutation(deleteDyanmicUiFn, {

        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {

                toast.success(res?.data?.message)
                refetch()
            }

            else {

                toast.warn(res?.data?.message)
                refetch()
            }


        }
    })

    return (

        <div className=" !bg-slate-100">
            <div className="flex justify-between">
                <div className="p-2">
                    <p className="text-xl !text-black font font-bold">
                        Page Design List
                    </p>
                </div>
                <div className="p-2 pt-5">
                    {/* <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Product Specification
          </Button> */}
                </div>
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2 px-3">
                    <span className="flex  gap-3">
                        <input
                            type="text"
                            value={search}
                            className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
                            placeholder="search"
                            style={{ border: "1px solid black" }}
                            onChange={(event) => setSearch(event.target.value)}
                        />
                    </span>
                    <span><Button variant="outlined" onClick={() => navigate(`/page-design/add`)} color="primary" size="small" className="">Add Page</Button></span>
                </div>
                <TableContainer
                    component={Paper}
                    // sx={{  }}
                    sx={{ width: "100%", maxHeight: 440 }}
                    className="!text-black !mx-auto !bg-white overflow-auto px-2"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    ID
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    <div className="w-44">PAGE NAME</div>
                                </TableCell>

                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Page Value

                                </TableCell>



                                <TableCell
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    <div className="w-36"> ACTION</div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="!bg-red">
                            {data &&
                                data?.data?.data?.map((row, index) => (
                                    <TableRow key={row.id} className="!text-slate-700">
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {index + 1}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.page_type_name
                                                ? row?.page_type_name
                                                : "--"}

                                        </TableCell>

                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            <PageValue page_format={row?.page_format} />

                                        </TableCell>




                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            <IconButton onClick={() => navigate("/page-design/update", {

                                                state: row
                                            })}>

                                                <Edit color="primary" />
                                            </IconButton>

                                            <IconButton onClick={() => DeleteMsg({ page_format_id: row?.id })}>

                                                <Delete color="error" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}
